export default "__VITE_ASSET__kPOeeCoL__"